import apiClient from "../api/api";

// =========================================================
// 1. ADMIN: SABHI REPORTS
// =========================================================

export const getReports = async () => {
  try {
    const response = await apiClient.get("/reports");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// =========================================================
// 2. LOGIN USER KI APNI REPORTS
// =========================================================

export const getMyReports = async () => {
  try {
    const response = await apiClient.get("/reports/my-reports");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// =========================================================
// 3. PUBLIC RESOLVED / PUBLISHED NGO REPORTS
// =========================================================

export const getPublicResolvedReports = async () => {
  try {
    const response = await apiClient.get("/reports/public/resolved");

    console.log("========== PUBLIC NGO RESOLVED REPORTS ==========");
    console.log(response.data);
    console.log("==================================================");

    return response.data;
  } catch (error) {
    console.error("Get Public Resolved Reports Error:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// =========================================================
// 4. PUBLISHED VOLUNTEER RESPONSES
// =========================================================

export const getPublishedVolunteerResponses = async () => {
  try {
    const response = await apiClient.get("/reports/volunteer-tasks/published");

    console.log("========== PUBLISHED VOLUNTEER RESPONSES ==========");
    console.log(response.data);
    console.log("====================================================");

    return response.data;
  } catch (error) {
    console.error("Get Published Volunteer Responses Error:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// =========================================================
// 5. CREATE REPORT
// =========================================================

export const createReport = async (reportData) => {
  try {
    const response = await apiClient.post("/reports", reportData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// =========================================================
// 6. GET REPORTS BY STATUS
// =========================================================

export const getReportsByStatus = async (status) => {
  try {
    const endpoint = status === "All" ? "/reports" : `/reports?status=${encodeURIComponent(status)}`;
    const response = await apiClient.get(endpoint);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// =========================================================
// 7. UPDATE REPORT ASSIGNMENT
// =========================================================

export const updateReportAssignment = async (reportId, assignmentData) => {
  try {
    if (!reportId) throw new Error("Report ID is required.");
    const response = await apiClient.put(`/reports/${reportId}/assign`, assignmentData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// =========================================================
// 8. FORWARD REPORT TO NGO
// =========================================================

export const forwardReportToNGO = async (reportId, ngoData) => {
  try {
    if (!reportId) throw new Error("Report ID is required.");
    if (!ngoData?.ngoName?.trim()) throw new Error("NGO name is required.");

    const payload = {
      ngoName: ngoData.ngoName.trim(),
      ngoEmail: ngoData.ngoEmail || "",
      ngoPhone: ngoData.ngoPhone || "",
      ngoAddress: ngoData.ngoAddress || "",
      notes: ngoData.notes || "",
    };

    console.log("========== FORWARD REPORT TO NGO ==========");
    console.log("Report ID:", reportId);
    console.log("NGO Data:", payload);
    console.log("============================================");

    const response = await apiClient.put(`/reports/${reportId}/forward-ngo`, payload);

    console.log("========== FORWARD NGO RESPONSE ==========");
    console.log(response.data);
    console.log("==========================================");

    return response.data;

  } catch (error) {
    console.error("Forward Report To NGO Error:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// =========================================================
// 9. UPDATE NGO RESPONSE / RESOLUTION
// =========================================================

export const updateNGOResponse = async (reportId, resolutionData) => {
  try {
    if (!reportId) throw new Error("Report ID is required.");
    if (!resolutionData?.ngoName?.trim()) throw new Error("NGO name is required.");
    if (!resolutionData?.response?.trim()) throw new Error("NGO response is required.");
    if (!resolutionData?.resolutionDetails?.trim()) throw new Error("Resolution details are required.");

    const formData = new FormData();

    formData.append("ngoName", resolutionData.ngoName.trim());
    if (resolutionData.ngoEmail) formData.append("ngoEmail", resolutionData.ngoEmail);
    if (resolutionData.ngoPhone) formData.append("ngoPhone", resolutionData.ngoPhone);
    if (resolutionData.ngoAddress) formData.append("ngoAddress", resolutionData.ngoAddress);
    formData.append("response", resolutionData.response.trim());
    formData.append("resolutionDetails", resolutionData.resolutionDetails.trim());
    if (resolutionData.resolutionDate) formData.append("resolutionDate", resolutionData.resolutionDate);
    if (resolutionData.status) formData.append("status", resolutionData.status);
    formData.append("showOnWebsite", resolutionData.showOnWebsite ? "true" : "false");
    if (resolutionData.removeResolutionImage) formData.append("removeResolutionImage", "true");

    const image = resolutionData.resolutionImage || resolutionData.responseImage || resolutionData.image || null;
    if (image) {
      let file = image;
      if (typeof image === "object" && image.file) file = image.file;
      if ((typeof File !== "undefined" && file instanceof File) || (typeof Blob !== "undefined" && file instanceof Blob)) {
        formData.append("resolutionImage", file);
      }
    }

    console.log("========== UPDATE NGO RESPONSE ==========");
    console.log("Report ID:", reportId);
    console.log("NGO Name:", resolutionData.ngoName);
    console.log("Show On Website:", resolutionData.showOnWebsite);
    console.log("Status:", resolutionData.status);
    console.log("Has Image:", !!image);
    console.log("==========================================");

    const response = await apiClient.put(`/reports/${reportId}/ngo-response`, formData);

    console.log("========== NGO RESPONSE SAVED ==========");
    console.log(response.data);
    console.log("=========================================");

    return response.data;

  } catch (error) {
    console.error("Update NGO Response Error:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// =========================================================
// 10. DELETE VOLUNTEER RESPONSE / TASK
// =========================================================

export const deleteVolunteerResponse = async (taskId) => {
  try {
    if (!taskId) throw new Error("Volunteer response ID is required.");

    console.log("========== DELETE VOLUNTEER RESPONSE ==========");
    console.log("Task ID:", taskId);
    console.log("Endpoint:", `/reports/volunteer-tasks/${taskId}`);
    console.log("================================================");

    const response = await apiClient.delete(`/reports/volunteer-tasks/${taskId}`);

    console.log("========== VOLUNTEER RESPONSE DELETED ==========");
    console.log(response.data);
    console.log("=================================================");

    return response.data;

  } catch (error) {
    console.error("Delete Volunteer Response Error:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};